import { Grid } from '@mui/material'
import { AllocationCard } from './AllocationCard'
import { EnrollmentCard } from './EnrollmentCard'
import { type programSummary } from '../../../../core/types'

export interface listCardsProps {
  facilityCapacity: number
  allocations: programSummary[]
}

export function ListCards (props: listCardsProps): JSX.Element {
  return (<Grid sx={{ width: '100%', display: 'flex', gap: 2, flexDirection: 'row' }}>
    <AllocationCard allocationType={props.allocations} />
    <EnrollmentCard maxCapacity={props.facilityCapacity} enrollments={props.allocations} />
  </Grid>)
}
